import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const IzletOpis: IModel = {
  title: "Izlet opis",
  apiPath: "hps/izleti/{id}/opisi",
  httpUpdateVerb: "put",
  forms: {
    default: {
      fields: ["poglavlje_id", "sadrzaj"],
    },
    edit: {
      fields: [{source: "poglavlje_id", readonly: true}, "sadrzaj"],
    },
  },
  listViews: {
    default: {
      fields: ["id", "poglavlje_id", "sadrzaj", "created_on", "modified_on"],
      hidden: ["id", "created_on", "modified_on"],
    },
  },
  fields: [
    coreFields.id,
    commonFields.wkt,
    {
      title: "Poglavlje",
      source: "poglavlje_id",
      ttoken: "hps.izlet.poglavlje",
      type: "picker",
      subModel: {
        apiPath: 'hps/izleti/opisi/poglavlja?need_for=picker',
        format: '{label}',
      },
      validation: {
        required: true,
      },
      translate: true,
    },
    {
      title: "Sadržaj",
      source: "sadrzaj",
      ttoken: "common.sadrzaj",
      type: "multiline",
      rows: 10,
      validation: {
        required: true,
        maxLength: 1500
      },
    },
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default IzletOpis;
